import AppAffiliateTemplateEditing from "./appaffiliatetemplateediting"
import AppAffiliateTemplateUI from "./appaffiliatetemplateui"
import Plugin from "@ckeditor/ckeditor5-core/src/plugin"

export default class AppAffiliateTemplate extends Plugin {
  static get requires() {
    return [AppAffiliateTemplateEditing, AppAffiliateTemplateUI]
  }

  static get pluginName() {
    return "AppAffiliateTemplate"
  }
}
